const map = {
	"./biologis.svg": 2097,
	"./biologis_gim.png": 9338,
	"./biologis_gim.svg": 2869,
	"./eye-slash.svg": 5240,
	"./eye.svg": 4384,
	"./icons/dna-analysis.svg": 5710,
	"./icons/dna.svg": 2519,
	"./icons/favorites.svg": 4079,
	"./icons/help.svg": 473,
	"./icons/info.svg": 404,
	"./icons/med-check.svg": 1305,
	"./icons/pills.svg": 8688,
	"./icons/settings.svg": 9903,
	"./icons/star-outline.svg": 1945,
	"./icons/star.svg": 4904,
	"./icons/support.svg": 189,
	"./logos.svg": 2515,
	"./rbk.png": 5771,
	"./rbkikp.png": 7763,
	"./tutorial/de/tutorial_01.png": 8961,
	"./tutorial/de/tutorial_02.png": 8794,
	"./tutorial/de/tutorial_03.png": 6371,
	"./tutorial/de/tutorial_04.png": 6204,
	"./tutorial/en/tutorial_01.png": 1765,
	"./tutorial/en/tutorial_02.png": 3934,
	"./tutorial/en/tutorial_03.png": 3431,
	"./tutorial/en/tutorial_04.png": 1288
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;